import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { NavLink } from 'react-router-dom'
import { Sider, Icon, Layout } from './common/Ant'
import { hasPermission, hasRole } from '../utils/hasPermission'
import { flagEnabled } from '../utils/config'
import { USER_PERMISSIONS, ROLES } from '../constants'
import { version } from '../../package.json'

const isCommunicationsEnabled = flagEnabled('REACT_APP_ENABLE_COMMUNICATIONS')

class SideNav extends Component {
  static propTypes = {
    isAuthorized: PropTypes.bool.isRequired,
    isSideNavCollapsed: PropTypes.bool.isRequired,
    toggleSideNavCollapse: PropTypes.func.isRequired,
    windowWidth: PropTypes.number.isRequired,
  }

  render() {
    const {
      isAuthorized,
      isSideNavCollapsed,
      toggleSideNavCollapse,
      windowWidth,
    } = this.props

    const canToggleMenu = windowWidth < 960
    const sideNavTriggerClassNames = cx('pointer fixed f3 z-9999', {
      dn: !canToggleMenu || !isSideNavCollapsed,
    })

    const widthCheckedCanToggleMenu = !isSideNavCollapsed
      ? toggleSideNavCollapse
      : () => null

    return (
      isAuthorized && (
        <Layout>
          <Sider
            width={175}
            className="fixed top-0 pt2 pt0-l SideNav min-vh-100 z-1000"
            style={!canToggleMenu ? { top: 65 } : null}
            trigger={null}
            breakpoint="lg"
            collapsed={canToggleMenu && isSideNavCollapsed}
            collapsedWidth="0"
          >
            <nav className="Menu ant-menu ant-menu-inline">
              {!hasRole(ROLES.HILTI_USER) && (
                <div className="ant-menu-item" key="dashboard">
                  <NavLink
                    to="/dashboard"
                    activeClassName="fw7"
                    onClick={widthCheckedCanToggleMenu}
                  >
                    <Icon type="dashboard" /> Dashboard
                  </NavLink>
                </div>
              )}
              {(hasPermission(USER_PERMISSIONS.VIEW_ALERTS) ||
                hasPermission(USER_PERMISSIONS.VIEW_GATEWAY_ALERTS)) && (
                <div className="ant-menu-item" key="alerts">
                  <NavLink
                    to="/alerts"
                    activeClassName="fw7"
                    onClick={widthCheckedCanToggleMenu}
                  >
                    <Icon type="alert" /> Alerts
                  </NavLink>
                </div>
              )}
              {hasRole(
                ROLES.JOBSITE_ADMIN,
                ROLES.ORGANIZATION_ADMIN,
                ROLES.PILLAR_CONTRACTOR,
                ROLES.PILLAR_ADMIN,
                ROLES.SUPER_ADMIN
              ) && (
                <div className="ant-menu-item" key="sites">
                  <NavLink
                    to="/sites"
                    activeClassName="fw7"
                    onClick={widthCheckedCanToggleMenu}
                  >
                    <Icon type="environment-o" /> Sites
                  </NavLink>
                </div>
              )}
              {hasPermission(USER_PERMISSIONS.VIEW_ALL_DEPLOYMENTS) && (
                <div className="ant-menu-item" key="deployments">
                  <NavLink
                    to="/deployments"
                    activeClassName="fw7"
                    onClick={widthCheckedCanToggleMenu}
                  >
                    <Icon type="gift" /> Deployments
                  </NavLink>
                </div>
              )}
              {hasPermission(USER_PERMISSIONS.VIEW_REPORT) && (
                <div className="ant-menu-item" key="reports">
                  <NavLink
                    to="/reports"
                    activeClassName="fw7"
                    onClick={widthCheckedCanToggleMenu}
                  >
                    <Icon type="line-chart" /> Reports
                  </NavLink>
                </div>
              )}
              {hasPermission(USER_PERMISSIONS.VIEW_THRESHOLD) && (
                <div className="ant-menu-item" key="rules">
                  <NavLink
                    to="/rules"
                    activeClassName="fw7"
                    onClick={widthCheckedCanToggleMenu}
                  >
                    <Icon type="exception" /> Rules
                  </NavLink>
                </div>
              )}
              {hasPermission(USER_PERMISSIONS.VIEW_POD) && (
                <div className="ant-menu-item" key="inventory">
                  <NavLink
                    to="/inventory/all/pods"
                    activeClassName="fw7"
                    isActive={() =>
                      /.*\/inventory\/.*/.test(global.location.pathname)
                    }
                    onClick={widthCheckedCanToggleMenu}
                  >
                    <Icon type="qrcode" /> Inventory
                  </NavLink>
                </div>
              )}
              {hasPermission(USER_PERMISSIONS.VIEW_COMPANY) && (
                <div className="ant-menu-item" key="companies">
                  <NavLink
                    to="/companies"
                    activeClassName="fw7"
                    onClick={widthCheckedCanToggleMenu}
                  >
                    <Icon type="solution" /> Companies
                  </NavLink>
                </div>
              )}
              {hasPermission(USER_PERMISSIONS.VIEW_USER) && (
                <div className="ant-menu-item" key="users">
                  <NavLink
                    to="/users"
                    activeClassName="fw7"
                    onClick={widthCheckedCanToggleMenu}
                  >
                    <Icon type="team" /> Users
                  </NavLink>
                </div>
              )}
              {hasRole(ROLES.SUPER_ADMIN, ROLES.PILLAR_ADMIN) && (
                <div className="ant-menu-item" key="internal-reports">
                  <NavLink
                    to="/internal-reports"
                    activeClassName="fw7"
                    onClick={widthCheckedCanToggleMenu}
                  >
                    <Icon type="file-text" /> Internal Reports
                  </NavLink>
                </div>
              )}
              {isCommunicationsEnabled &&
                hasPermission(USER_PERMISSIONS.ENABLE_COMMS_HUB) && (
                  <div className="ant-menu-item" key="communications">
                    <NavLink
                      to="/communications"
                      activeClassName="fw7"
                      onClick={widthCheckedCanToggleMenu}
                    >
                      <Icon type="message" /> Communications
                    </NavLink>
                  </div>
                )}
              {(hasPermission(USER_PERMISSIONS.VIEW_TAG) ||
                hasPermission(USER_PERMISSIONS.VIEW_ACTION_REPORT_CAUSES)) && (
                <div className="ant-menu-item" key="metadata">
                  <NavLink
                    to="/metadata/all"
                    activeClassName="fw7"
                    onClick={widthCheckedCanToggleMenu}
                    isActive={() =>
                      /.*\/metadata\/.*/.test(global.location.pathname)
                    }
                  >
                    <Icon type="tag-o" /> Metadata
                  </NavLink>
                </div>
              )}
              {hasPermission(USER_PERMISSIONS.VIEW_WORKFLOW) && (
                <div className="ant-menu-item" key="workflows">
                  <NavLink
                    to="/workflows"
                    activeClassName="fw7"
                    onClick={widthCheckedCanToggleMenu}
                  >
                    <Icon type="audit" /> Workflows
                  </NavLink>
                </div>
              )}
              {hasRole(
                ROLES.SUPER_ADMIN,
                ROLES.PILLAR_ADMIN,
                ROLES.HILTI_USER
              ) &&
                hasPermission(USER_PERMISSIONS.ENABLE_EROS) && (
                  <div className="ant-menu-item" key="hilti-dashboard">
                    <NavLink
                      to="/hilti"
                      activeClassName="fw7"
                      onClick={widthCheckedCanToggleMenu}
                    >
                      <Icon type="bars" /> Hilti Dashboard
                    </NavLink>
                  </div>
                )}
              {hasPermission(USER_PERMISSIONS.ENABLE_API) && (
                <div className="ant-menu-item" key="developer">
                  <NavLink
                    to="/developer"
                    activeClassName="fw7"
                    onClick={widthCheckedCanToggleMenu}
                  >
                    <Icon type="api" /> Developer
                  </NavLink>
                </div>
              )}
              {hasPermission(USER_PERMISSIONS.MANAGE_NETWORK) && (
                <div className="ant-menu-item" key="networks">
                  <NavLink
                    to="/networks"
                    activeClassName="fw7"
                    onClick={widthCheckedCanToggleMenu}
                  >
                    <Icon type="gateway" /> Networks
                  </NavLink>
                </div>
              )}
            </nav>
            <div className="fixed bottom-0 left-0 moon-gray pl3 pb3 f7">
              v{version}{' '}
              {process.env.REACT_APP_SHORT_HASH
                ? `(${process.env.REACT_APP_SHORT_HASH})`
                : ''}
            </div>
          </Sider>
          <Icon
            className={sideNavTriggerClassNames}
            style={{ top: 20, left: 13 }}
            type={isSideNavCollapsed ? 'menu-unfold' : 'menu-fold'}
            onClick={toggleSideNavCollapse}
          />
          {!isSideNavCollapsed && (
            <div
              className="fixed top-0 right-0 bottom-0 left-0 bg-black-60 z-999 overflow-auto outline-0"
              onClick={toggleSideNavCollapse}
            />
          )}
        </Layout>
      )
    )
  }
}

export default SideNav
